import {Component, OnInit} from '@angular/core';
import {Constants} from '../Services/Constants';
import {HTTPService} from '../Services/http.service';
import {Observable}   from 'rxjs/Observable';
import {filter} from '../App/search.pipe';
import {DatePipe} from "@angular/common";
import {MySharedService} from '../App/shared.service'
import { ActivatedRoute, Router } from '@angular/router';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any,Columns?: any): void;

@Component({
    templateUrl: './AppViews/Vendors/vendors.html'  
})

export class VendorsComponent implements OnInit {
    constants:Constants;
    vendorsList:any=[];
    vendorsStatusItems:any=[];    
    public Search: any = "";
    public filterVendorsStatus:any="";
    public showLoader = false;
    
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _datepipe: DatePipe){
      
        this.constants = new Constants();
         this.filterVendorsStatus = this.constants.enumCustomerStatus["Active"];
    }

     ngOnInit(){
         this.getStatus();        
         this.getVendors();
     }

    ngAfterViewInit() {
        
        $("#show-filter").click(function(){$(".filter-form").slideToggle()});
    }
    
    public getStatus(){
         this.showLoader=true;
        this._httpService.ajaxPost('Common/GetParameter', { "ParameterTypeId" : this.constants.enumParamterTypeName["UserStatus"] }).subscribe(
            data => {
                this.vendorsStatusItems = data["Parameter"];
            },
            			           err =>{
 this.showLoader=false;
                this._sharedService.ShowMessage(this.constants.globalError);
			},
			 
() =>{			 this.showLoader=false;
          
				}
				
        );
    }

    public clearFilter(){
        this.filterVendorsStatus = this.constants.enumCustomerStatus["Active"];
        this.Search = "";
    }

    public getVendors(){
         this.showLoader=true;
        this._httpService.ajaxPost('Vendors/GetVendors', {"VendorId":0,"IsActive":this.filterVendorsStatus}).subscribe(
            data => {
                this.vendorsList = data["Vendors"];
                console.log(this.vendorsList);
                
            },
            			           err =>{
  this.showLoader=false;
                this._sharedService.ShowMessage(this.constants.globalError);
			},
			 
() =>{			 this.showLoader=false;
               
				}
				
        );
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Vendors/vendors.component.ts
 **/